import React from 'react'
import Slider from './Slider'
import Catacards from './Catacards'
import Upperfooter from './Upperfooter'
import Inspiration from './Inspiration'
import Services from './services'
import Contactusbutton from './Contactusbutton'


const Home = () => {
  return (
    <div>
   
    <Slider/>
    <Catacards/>
    <Upperfooter/>
    <Inspiration/>
    <Services/>
    <Contactusbutton/>

    </div>
  )
}

export default Home
